export const LOCATION_LOAD_TIMEOUT = 30000;
